"use client"
import React, { useState } from "react";
import { useConfig } from "@/lib/providers/ConfigProvider";

import "@/components/locator/LocatorBrandBadge.css";

// circular logo pinned to the upper right of the locator map; clicking it shows the heading and text
const LocatorBrandBadge = ({ logoAssetId, heading, text }) => {
  const { apiUrl } = useConfig();
  const [expanded, setExpanded] = useState(false);
  const hasDetails = !!(heading || text);

  if (!logoAssetId) return null;

  return (
    <div className={`locator-brand-badge${expanded ? " expanded" : ""}`}>
      <button
        type="button"
        className="locator-brand-badge-logo"
        onClick={() => hasDetails && setExpanded(!expanded)}
        aria-expanded={hasDetails ? expanded : undefined}
        aria-label={heading ?? "Logo"}
      >
        <img src={`${apiUrl}/api/files/${logoAssetId}/sq/lg`} alt={heading ?? ""} />
      </button>
      {expanded && hasDetails && (
        <div className="locator-brand-badge-card" onClick={() => setExpanded(false)}>
          {heading && <h5>{heading}</h5>}
          {text && <p>{text}</p>}
        </div>
      )}
    </div>
  );
};

export default LocatorBrandBadge;
